/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, EventEmitter, Output } from '@angular/core';
import { I18nService } from '@dm/core';
import { SWITCH } from 'app/config';
import { FeatureConfig } from 'app/config/feature';

@Component({
    selector: 'app-san-resource',
    templateUrl: './san-resource.component.html',
    styleUrls: ['./san-resource.component.scss'],
})
export class SanResourceComponent {
    SWITCH = SWITCH;
    FeatureConfig = FeatureConfig;
    @Output() selectedResource: EventEmitter<string> = new EventEmitter();

    constructor(public i18n: I18nService) {
    }

    handleSelectedResource(type: string): void {
        this.selectedResource.emit(type);
    }
}
